// @ts-ignore:next-line need type definition file for vp/auth
import VistaprintAuth from '@vp/auth';

export const getShopperId = (): string => {
  const auth = new VistaprintAuth.WebAuth();
  const shopperId: string =
    auth.isSignedIn() &&
    auth.getProfile()['https://claims.cimpress.io/canonical_id'];
  return shopperId;
};

export const logout = () => {
  const auth = new VistaprintAuth.WebAuth();
  auth.signOut();
};
